import { ReactNode } from 'react';

type Props = {
  children: ReactNode;
  label: string;
};

const OfferStatsCard = ({ children, label }: Props) => (
  <div className="rounded-lg border border-border bg-card p-4 flex flex-col items-start gap-1">
    <p className="text-sm text-foreground mb-1">{label}</p>
    <>{children}</>
  </div>
);

export default OfferStatsCard;
